module.exports = __webpack_public_path__ + "img/assistant.39b627ab.png";